"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultForceOptions = exports.defaultComboForceOptions = exports.emptyGraphData = void 0;
exports.emptyGraphData = {
    combos: [],
    edges: [],
    nodes: []
};
exports.defaultComboForceOptions = {
    comboSpacing: 250,
    linkDistance: 200,
    nodeSpacing: 90,
    preventOverlap: true
};
exports.defaultForceOptions = {
    linkDistance: 250,
    nodeSpacing: 40,
    preventOverlap: true
};
//# sourceMappingURL=DataSecurityApplicationOverview.js.map